import styled from 'styled-components';

const Title = styled.div`
  ${({ theme }) => theme.fontFamily.mainFont.xLargeExtraBold}
  align-self: center;
  width: 100%;
`;

export default Title;
